import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddHomeWorkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_home_work"}/>
}
